import { useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Willkommen zurück");
      navigate(location.state?.from?.pathname || "/admin", { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#32104F] px-5">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Logo variant="full" className="h-44 w-auto mx-auto" />
          <p className="text-sm text-[#F4C542] mt-2 uppercase tracking-[0.3em]">Administration</p>
        </div>
        <form onSubmit={submit} className="space-y-5 bg-[#FFF9F2] p-8 rounded-md shadow-2xl">
          <div>
            <Label htmlFor="email">E-Mail</Label>
            <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12" autoComplete="username" />
          </div>
          <div>
            <Label htmlFor="password">Passwort</Label>
            <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12" autoComplete="current-password" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full bg-[#F4C542] text-[#32104F] font-medium hover:bg-[#D85CA4] hover:text-[#FFF9F2] h-12">
            {loading ? "Anmelden…" : "Anmelden"}
          </Button>
        </form>
      </div>
    </div>
  );
}
